export const environment = {
  production: false,
  apiUrl: 'https://dev-api.everwhisper.org',
  googleClientId: '476142596425-0432qqebjlctp7tmp2c41q342fbvkene.apps.googleusercontent.com', // Set your Google OAuth Client ID here
};
